// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file accounts/get_my_account.proto (package protos.accounts, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { WorkFunction } from "../general/work_function_pb";
import { file_general_work_function } from "../general/work_function_pb";
import type { WorkDepartment } from "../general/work_department_pb";
import { file_general_work_department } from "../general/work_department_pb";
import type { WorkLocation } from "../general/work_location_pb";
import { file_general_work_location } from "../general/work_location_pb";
import type { EyeColor } from "../general/eye_color_pb";
import { file_general_eye_color } from "../general/eye_color_pb";
import type { HairColor } from "../general/hair_color_pb";
import { file_general_hair_color } from "../general/hair_color_pb";
import type { Gender } from "../general/gender_pb";
import { file_general_gender } from "../general/gender_pb";
import type { Ethnicity } from "../general/ethnicity_pb";
import { file_general_ethnicity } from "../general/ethnicity_pb";
import type { SpokenLanguage } from "../general/spoken_language_pb";
import { file_general_spoken_language } from "../general/spoken_language_pb";
import type { ShowcaseLayoutType } from "./showcase_layout_type_pb";
import { file_accounts_showcase_layout_type } from "./showcase_layout_type_pb";
import type { MyProfileCover } from "./my_profile_cover_pb";
import { file_accounts_my_profile_cover } from "./my_profile_cover_pb";
import type { MyAccount } from "../entities/app/my_account/my_account_pb";
import { file_entities_app_my_account_my_account } from "../entities/app/my_account/my_account_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file accounts/get_my_account.proto.
 */
export const file_accounts_get_my_account: GenFile = /*@__PURE__*/
  fileDesc("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", [file_general_work_function, file_general_work_department, file_general_work_location, file_general_eye_color, file_general_hair_color, file_general_gender, file_general_ethnicity, file_general_spoken_language, file_accounts_showcase_layout_type, file_accounts_my_profile_cover, file_entities_app_my_account_my_account]);

/**
 * @generated from message protos.accounts.GetMyAccountRequest
 */
export type GetMyAccountRequest = Message<"protos.accounts.GetMyAccountRequest"> & {
  /**
   * @generated from field: protos.accounts.GetMyAccountRequest.Params params = 1;
   */
  params?: GetMyAccountRequest_Params | undefined;
};

/**
 * Describes the message protos.accounts.GetMyAccountRequest.
 * Use `create(GetMyAccountRequestSchema)` to create a new message.
 */
export const GetMyAccountRequestSchema: GenMessage<GetMyAccountRequest> = /*@__PURE__*/
  messageDesc(file_accounts_get_my_account, 0);

/**
 * @generated from message protos.accounts.GetMyAccountRequest.Params
 */
export type GetMyAccountRequest_Params = Message<"protos.accounts.GetMyAccountRequest.Params"> & {
  /**
   * @generated from field: bool include_union_memberships = 1;
   */
  includeUnionMemberships: boolean;
};

/**
 * Describes the message protos.accounts.GetMyAccountRequest.Params.
 * Use `create(GetMyAccountRequest_ParamsSchema)` to create a new message.
 */
export const GetMyAccountRequest_ParamsSchema: GenMessage<GetMyAccountRequest_Params> = /*@__PURE__*/
  messageDesc(file_accounts_get_my_account, 0, 0);

/**
 * @generated from message protos.accounts.GetMyAccountResponse
 */
export type GetMyAccountResponse = Message<"protos.accounts.GetMyAccountResponse"> & {
  /**
   * @generated from field: protos.accounts.GetMyAccountResponse.Result result = 1;
   */
  result?: GetMyAccountResponse_Result | undefined;
};

/**
 * Describes the message protos.accounts.GetMyAccountResponse.
 * Use `create(GetMyAccountResponseSchema)` to create a new message.
 */
export const GetMyAccountResponseSchema: GenMessage<GetMyAccountResponse> = /*@__PURE__*/
  messageDesc(file_accounts_get_my_account, 1);

/**
 * @generated from message protos.accounts.GetMyAccountResponse.Result
 */
export type GetMyAccountResponse_Result = Message<"protos.accounts.GetMyAccountResponse.Result"> & {
  /**
   * @generated from field: protos.entities.app.my_account.MyAccount my_account = 16;
   */
  myAccount?: MyAccount | undefined;

  /**
   * @generated from field: string account_id = 1 [deprecated = true];
   * @deprecated
   */
  accountId: string;

  /**
   * @generated from field: string name = 2 [deprecated = true];
   * @deprecated
   */
  name: string;

  /**
   * @generated from field: string bio = 3 [deprecated = true];
   * @deprecated
   */
  bio: string;

  /**
   * @generated from field: string pfp_url = 4 [deprecated = true];
   * @deprecated
   */
  pfpUrl: string;

  /**
   * @generated from field: repeated protos.accounts.MyProfileCover covers = 5 [deprecated = true];
   * @deprecated
   */
  covers: MyProfileCover[];

  /**
   * @generated from field: protos.accounts.ShowcaseLayoutType showcase_layout_type = 6 [deprecated = true];
   * @deprecated
   */
  showcaseLayoutType: ShowcaseLayoutType;

  /**
   * @generated from field: protos.accounts.GetMyAccountResponse.Result.Contact contact = 7 [deprecated = true];
   * @deprecated
   */
  contact?: GetMyAccountResponse_Result_Contact | undefined;

  /**
   * @generated from field: protos.accounts.GetMyAccountResponse.Result.WorkFunctionData main_work_function = 8 [deprecated = true];
   * @deprecated
   */
  mainWorkFunction?: GetMyAccountResponse_Result_WorkFunctionData | undefined;

  /**
   * @generated from field: repeated protos.accounts.GetMyAccountResponse.Result.WorkFunctionData other_work_functions = 9 [deprecated = true];
   * @deprecated
   */
  otherWorkFunctions: GetMyAccountResponse_Result_WorkFunctionData[];

  /**
   * @generated from field: string default_project_cover_url = 10 [deprecated = true];
   * @deprecated
   */
  defaultProjectCoverUrl: string;

  /**
   * @generated from field: protos.accounts.GetMyAccountResponse.Result.InfoSheet info_sheet = 11 [deprecated = true];
   * @deprecated
   */
  infoSheet?: GetMyAccountResponse_Result_InfoSheet | undefined;

  /**
   * @generated from field: protos.general.WorkLocation main_work_location = 12 [deprecated = true];
   * @deprecated
   */
  mainWorkLocation: WorkLocation;

  /**
   * @generated from field: protos.accounts.GetMyAccountResponse.Result.Settings settings = 13 [deprecated = true];
   * @deprecated
   */
  settings?: GetMyAccountResponse_Result_Settings | undefined;

  /**
   * @generated from field: protos.accounts.GetMyAccountResponse.Result.JobAlerts job_alerts = 14 [deprecated = true];
   * @deprecated
   */
  jobAlerts?: GetMyAccountResponse_Result_JobAlerts | undefined;

  /**
   * @generated from field: repeated protos.accounts.GetMyAccountResponse.Result.UnionMembership union_memberships = 15 [deprecated = true];
   * @deprecated
   */
  unionMemberships: GetMyAccountResponse_Result_UnionMembership[];

  /**
   * We'll remove this in the future so use a higher number
   *
   * @generated from field: protos.accounts.GetMyAccountResponse.Result.SocialLinks social_links = 101 [deprecated = true];
   * @deprecated
   */
  socialLinks?: GetMyAccountResponse_Result_SocialLinks | undefined;
};

/**
 * Describes the message protos.accounts.GetMyAccountResponse.Result.
 * Use `create(GetMyAccountResponse_ResultSchema)` to create a new message.
 */
export const GetMyAccountResponse_ResultSchema: GenMessage<GetMyAccountResponse_Result> = /*@__PURE__*/
  messageDesc(file_accounts_get_my_account, 1, 0);

/**
 * @generated from message protos.accounts.GetMyAccountResponse.Result.WorkFunctionData
 */
export type GetMyAccountResponse_Result_WorkFunctionData = Message<"protos.accounts.GetMyAccountResponse.Result.WorkFunctionData"> & {
  /**
   * @generated from field: protos.general.WorkFunction function = 1;
   */
  function: WorkFunction;

  /**
   * @generated from field: protos.general.WorkDepartment department = 2;
   */
  department: WorkDepartment;
};

/**
 * Describes the message protos.accounts.GetMyAccountResponse.Result.WorkFunctionData.
 * Use `create(GetMyAccountResponse_Result_WorkFunctionDataSchema)` to create a new message.
 */
export const GetMyAccountResponse_Result_WorkFunctionDataSchema: GenMessage<GetMyAccountResponse_Result_WorkFunctionData> = /*@__PURE__*/
  messageDesc(file_accounts_get_my_account, 1, 0, 0);

/**
 * @generated from message protos.accounts.GetMyAccountResponse.Result.Contact
 */
export type GetMyAccountResponse_Result_Contact = Message<"protos.accounts.GetMyAccountResponse.Result.Contact"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;

  /**
   * @generated from field: string phone_number = 2;
   */
  phoneNumber: string;

  /**
   * @generated from field: string website = 3;
   */
  website: string;
};

/**
 * Describes the message protos.accounts.GetMyAccountResponse.Result.Contact.
 * Use `create(GetMyAccountResponse_Result_ContactSchema)` to create a new message.
 */
export const GetMyAccountResponse_Result_ContactSchema: GenMessage<GetMyAccountResponse_Result_Contact> = /*@__PURE__*/
  messageDesc(file_accounts_get_my_account, 1, 0, 1);

/**
 * @generated from message protos.accounts.GetMyAccountResponse.Result.SocialLinks
 */
export type GetMyAccountResponse_Result_SocialLinks = Message<"protos.accounts.GetMyAccountResponse.Result.SocialLinks"> & {
  /**
   * @generated from field: string instagram = 1;
   */
  instagram: string;

  /**
   * @generated from field: string facebook = 2;
   */
  facebook: string;

  /**
   * @generated from field: string linkedin = 3;
   */
  linkedin: string;

  /**
   * @generated from field: string imdb = 4;
   */
  imdb: string;
};

/**
 * Describes the message protos.accounts.GetMyAccountResponse.Result.SocialLinks.
 * Use `create(GetMyAccountResponse_Result_SocialLinksSchema)` to create a new message.
 */
export const GetMyAccountResponse_Result_SocialLinksSchema: GenMessage<GetMyAccountResponse_Result_SocialLinks> = /*@__PURE__*/
  messageDesc(file_accounts_get_my_account, 1, 0, 2);

/**
 * @generated from message protos.accounts.GetMyAccountResponse.Result.InfoSheet
 */
export type GetMyAccountResponse_Result_InfoSheet = Message<"protos.accounts.GetMyAccountResponse.Result.InfoSheet"> & {
  /**
   * @generated from field: uint32 height = 1;
   */
  height: number;

  /**
   * @generated from field: uint32 on_screen_age_start = 2;
   */
  onScreenAgeStart: number;

  /**
   * @generated from oneof protos.accounts.GetMyAccountResponse.Result.InfoSheet.optional_on_screen_age_end
   */
  optionalOnScreenAgeEnd: {
    /**
     * @generated from field: uint32 on_screen_age_end = 3;
     */
    value: number;
    case: "onScreenAgeEnd";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: protos.general.EyeColor eye_color = 4;
   */
  eyeColor: EyeColor;

  /**
   * @generated from field: protos.general.HairColor hair_color = 5;
   */
  hairColor: HairColor;

  /**
   * @generated from field: protos.general.Gender gender = 6;
   */
  gender: Gender;

  /**
   * @generated from field: protos.general.Ethnicity ethnicity = 7;
   */
  ethnicity: Ethnicity;

  /**
   * @generated from field: repeated protos.accounts.GetMyAccountResponse.Result.InfoSheetLanguage spoken_languages = 8;
   */
  spokenLanguages: GetMyAccountResponse_Result_InfoSheetLanguage[];
};

/**
 * Describes the message protos.accounts.GetMyAccountResponse.Result.InfoSheet.
 * Use `create(GetMyAccountResponse_Result_InfoSheetSchema)` to create a new message.
 */
export const GetMyAccountResponse_Result_InfoSheetSchema: GenMessage<GetMyAccountResponse_Result_InfoSheet> = /*@__PURE__*/
  messageDesc(file_accounts_get_my_account, 1, 0, 3);

/**
 * @generated from message protos.accounts.GetMyAccountResponse.Result.InfoSheetLanguage
 */
export type GetMyAccountResponse_Result_InfoSheetLanguage = Message<"protos.accounts.GetMyAccountResponse.Result.InfoSheetLanguage"> & {
  /**
   * @generated from field: protos.general.SpokenLanguage language = 1;
   */
  language: SpokenLanguage;
};

/**
 * Describes the message protos.accounts.GetMyAccountResponse.Result.InfoSheetLanguage.
 * Use `create(GetMyAccountResponse_Result_InfoSheetLanguageSchema)` to create a new message.
 */
export const GetMyAccountResponse_Result_InfoSheetLanguageSchema: GenMessage<GetMyAccountResponse_Result_InfoSheetLanguage> = /*@__PURE__*/
  messageDesc(file_accounts_get_my_account, 1, 0, 4);

/**
 * @generated from message protos.accounts.GetMyAccountResponse.Result.Settings
 */
export type GetMyAccountResponse_Result_Settings = Message<"protos.accounts.GetMyAccountResponse.Result.Settings"> & {
  /**
   * @generated from field: protos.accounts.GetMyAccountResponse.Result.Settings.Notifications notifications = 1;
   */
  notifications?: GetMyAccountResponse_Result_Settings_Notifications | undefined;
};

/**
 * Describes the message protos.accounts.GetMyAccountResponse.Result.Settings.
 * Use `create(GetMyAccountResponse_Result_SettingsSchema)` to create a new message.
 */
export const GetMyAccountResponse_Result_SettingsSchema: GenMessage<GetMyAccountResponse_Result_Settings> = /*@__PURE__*/
  messageDesc(file_accounts_get_my_account, 1, 0, 5);

/**
 * @generated from message protos.accounts.GetMyAccountResponse.Result.Settings.Notifications
 */
export type GetMyAccountResponse_Result_Settings_Notifications = Message<"protos.accounts.GetMyAccountResponse.Result.Settings.Notifications"> & {
  /**
   * @generated from field: protos.accounts.GetMyAccountResponse.Result.Settings.Notifications.Push push = 1;
   */
  push?: GetMyAccountResponse_Result_Settings_Notifications_Push | undefined;
};

/**
 * Describes the message protos.accounts.GetMyAccountResponse.Result.Settings.Notifications.
 * Use `create(GetMyAccountResponse_Result_Settings_NotificationsSchema)` to create a new message.
 */
export const GetMyAccountResponse_Result_Settings_NotificationsSchema: GenMessage<GetMyAccountResponse_Result_Settings_Notifications> = /*@__PURE__*/
  messageDesc(file_accounts_get_my_account, 1, 0, 5, 0);

/**
 * @generated from message protos.accounts.GetMyAccountResponse.Result.Settings.Notifications.Push
 */
export type GetMyAccountResponse_Result_Settings_Notifications_Push = Message<"protos.accounts.GetMyAccountResponse.Result.Settings.Notifications.Push"> & {
  /**
   * @generated from field: bool new_job_application = 1;
   */
  newJobApplication: boolean;

  /**
   * @generated from field: bool connection_requested = 2;
   */
  connectionRequested: boolean;

  /**
   * @generated from field: bool connection_accepted = 3;
   */
  connectionAccepted: boolean;
};

/**
 * Describes the message protos.accounts.GetMyAccountResponse.Result.Settings.Notifications.Push.
 * Use `create(GetMyAccountResponse_Result_Settings_Notifications_PushSchema)` to create a new message.
 */
export const GetMyAccountResponse_Result_Settings_Notifications_PushSchema: GenMessage<GetMyAccountResponse_Result_Settings_Notifications_Push> = /*@__PURE__*/
  messageDesc(file_accounts_get_my_account, 1, 0, 5, 0, 0);

/**
 * @generated from message protos.accounts.GetMyAccountResponse.Result.JobAlerts
 */
export type GetMyAccountResponse_Result_JobAlerts = Message<"protos.accounts.GetMyAccountResponse.Result.JobAlerts"> & {
  /**
   * @generated from field: bool send_by_push = 1;
   */
  sendByPush: boolean;
};

/**
 * Describes the message protos.accounts.GetMyAccountResponse.Result.JobAlerts.
 * Use `create(GetMyAccountResponse_Result_JobAlertsSchema)` to create a new message.
 */
export const GetMyAccountResponse_Result_JobAlertsSchema: GenMessage<GetMyAccountResponse_Result_JobAlerts> = /*@__PURE__*/
  messageDesc(file_accounts_get_my_account, 1, 0, 6);

/**
 * @generated from message protos.accounts.GetMyAccountResponse.Result.UnionMembership
 */
export type GetMyAccountResponse_Result_UnionMembership = Message<"protos.accounts.GetMyAccountResponse.Result.UnionMembership"> & {
  /**
   * @generated from field: string union_id = 1;
   */
  unionId: string;

  /**
   * @generated from field: bool is_verified = 2;
   */
  isVerified: boolean;

  /**
   * @generated from field: uint32 year_joined = 3;
   */
  yearJoined: number;

  /**
   * @generated from field: string membership_status = 4;
   */
  membershipStatus: string;

  /**
   * @generated from field: string membership_id = 5;
   */
  membershipId: string;

  /**
   * @generated from field: repeated protos.accounts.GetMyAccountResponse.Result.UnionMembership.CertifiedFunction certified_functions = 6;
   */
  certifiedFunctions: GetMyAccountResponse_Result_UnionMembership_CertifiedFunction[];
};

/**
 * Describes the message protos.accounts.GetMyAccountResponse.Result.UnionMembership.
 * Use `create(GetMyAccountResponse_Result_UnionMembershipSchema)` to create a new message.
 */
export const GetMyAccountResponse_Result_UnionMembershipSchema: GenMessage<GetMyAccountResponse_Result_UnionMembership> = /*@__PURE__*/
  messageDesc(file_accounts_get_my_account, 1, 0, 7);

/**
 * @generated from message protos.accounts.GetMyAccountResponse.Result.UnionMembership.CertifiedFunction
 */
export type GetMyAccountResponse_Result_UnionMembership_CertifiedFunction = Message<"protos.accounts.GetMyAccountResponse.Result.UnionMembership.CertifiedFunction"> & {
  /**
   * @generated from field: protos.general.WorkFunction function = 1;
   */
  function: WorkFunction;
};

/**
 * Describes the message protos.accounts.GetMyAccountResponse.Result.UnionMembership.CertifiedFunction.
 * Use `create(GetMyAccountResponse_Result_UnionMembership_CertifiedFunctionSchema)` to create a new message.
 */
export const GetMyAccountResponse_Result_UnionMembership_CertifiedFunctionSchema: GenMessage<GetMyAccountResponse_Result_UnionMembership_CertifiedFunction> = /*@__PURE__*/
  messageDesc(file_accounts_get_my_account, 1, 0, 7, 0);

